export const ProductNames = {
  BCP: 'Business Credit Platform',
  AAADiploma: 'AAA Diploma'
}

export const isProductIsBusinessCreditPlatform = (productName: string) => productName === ProductNames.BCP;

export const isProductIsDRSOrCI = ['274','294'];
